export const CurrentUserApiDataUserType = {
  Client: 'client',
  Funder: 'funder',
} as const;

export type CurrentUserApiDataUserType = (typeof CurrentUserApiDataUserType)[keyof typeof CurrentUserApiDataUserType];

export interface CurrentUserApiData {
  userType: CurrentUserApiDataUserType;
  id: string;
  email: string;
  firstname: string;
  lastname: string;
}
